class HeaderStripeCountdown extends HTMLElement {
  connectedCallback() {
    const endValue = (this.dataset.end || '').trim();
    if (!endValue) return;

    // Liquid emits an absolute Unix epoch in milliseconds; fall back to Date
    // parsing in case a raw date string is ever supplied.
    const epoch = Number(endValue);
    this.endTime = Number.isFinite(epoch) ? epoch : new Date(endValue).getTime();
    if (Number.isNaN(this.endTime) || this.endTime <= 0) return;

    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');

    this.tick = this.tick.bind(this);
    this.tick();
    this.intervalId = window.setInterval(this.tick, 1000);
  }

  disconnectedCallback() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  tick() {
    const diff = Math.max(0, this.endTime - Date.now());
    const totalSeconds = Math.floor(diff / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');

    if (diff === 0 && this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
      this.classList.add('is-ended');
      this.dispatchEvent(new CustomEvent('theme:countdown:ended', { bubbles: true }));
    }
  }
}

if (!customElements.get('header-stripe-countdown')) {
  customElements.define('header-stripe-countdown', HeaderStripeCountdown);
}
